function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "tw-flex tw-gap-x-5px tw-items-center"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: 'La tua ricerca è stata salvata con successo'
}, null, -1 /* HOISTED */);
var _hoisted_4 = {
  "class": "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_5 = {
  "class": "tw-grid tw-grid-cols-12-generic-request tw-mt-25px"
};
var _hoisted_6 = {
  "class": "tw-flex tw-items-center tw-justify-start tw-pl-10px"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  "class": "max-sm:tw-max-w-[200px] tw-mt-5px sm:tw-flex"
}, " Richiedi una consulenza mutuo gratuita ", -1 /* HOISTED */);
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  id: "required-phone",
  "class": "tw-grid tw-grid-cols-12-generic-request tw-mt-0"
};
var _hoisted_10 = {
  "class": "tw-text-12 tw-ml-5px tw-mb-10px tw-mt-20px"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-font-semibold"
}, "Conferma", -1 /* HOISTED */);
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  "class": "tw-flex tw-justify-center"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  key: 0,
  "class": "tw-text-w-danger tw-text-12",
  innerHTML: 'Si è verificato un errore'
};
import BaseToggle from "@vueEntry/UIKitComponents/BaseToggle.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { onBeforeMount, ref, computed } from "vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import { sendMortgage } from "@services/agencyAPI";
import { sendGAEvent } from "@utils/GaEvents";
import md5 from "blueimp-md5";
import GenericSuccessModal from "@vueEntry/Modals/GenericSuccessModal.vue";
import { addGenericRequest } from "@services/requestAPI";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf, helpers } from "@vuelidate/validators";
import { useValidator } from "@wkComposables/useValidator";
import { useCommonVars } from "@wkComposables/useCommonVars";
export default /*#__PURE__*/_defineComponent({
  __name: 'SaveSearchSuccessModal',
  props: {
    showModal: {
      type: Boolean,
      "default": false
    },
    labels: {},
    isUserLogged: {
      type: Boolean
    },
    email: {},
    name: {
      "default": ""
    },
    realEstateSearchBean: {},
    pageName: {
      "default": ""
    },
    publicUserId: {}
  },
  emits: ["closedModal"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var show = ref(false);
    var showError = ref(false);
    var showMessageSentSuccess = ref(false);
    var isLoading = ref(false);
    /*const isValidPhone = ref(null as Nullable<boolean>)*/
    var requestData = ref({
      toggleGeneric: false,
      toggleMortgage: false,
      email: "",
      name: null,
      phone: null
    });
    var rules = computed(function () {
      return {
        requestData: {
          phone: {
            requiredIf: requiredIf(function () {
              return requestData.value.toggleGeneric || requestData.value.toggleMortgage;
            }),
            isValidPhone: helpers.regex(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/)
          },
          name: {
            requiredIf: requiredIf(function () {
              return !props.isUserLogged && (requestData.value.toggleGeneric || requestData.value.toggleMortgage);
            })
          }
        }
      };
    });
    var _useValidator = useValidator(),
      isValid = _useValidator.isValid;
    var _useCommonVars = useCommonVars(),
      wkLabels = _useCommonVars.wkLabels;
    var v$ = useVuelidate(rules, {
      requestData: requestData
    });
    onBeforeMount(function () {
      show.value = props.showModal;
      requestData.value.email = props.email;
      requestData.value.name = props.name;
    });
    var _useCommonVars2 = useCommonVars(),
      cdn = _useCommonVars2.cdn;
    var closedModal = function closedModal() {
      emits("closedModal");
    };
    var submitRequest = function submitRequest() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var event_location, mortgageData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isLoading.value = true;
              event_location = "".concat(props.pageName, " - Modale salva ricerca - Success");
              mortgageData = {
                name: props.isUserLogged ? props.name : requestData.value.name,
                email: props.email,
                phone: requestData.value.phone,
                tenant: 1,
                realEstateSearchBean: props.realEstateSearchBean
              };
              _context.prev = 3;
              if (!requestData.value.toggleGeneric) {
                _context.next = 8;
                break;
              }
              sendGAEvent("generic_request_lead", {
                event_location: event_location,
                real_estate_place_id: null,
                real_estate_contract_type: null,
                real_estate_typology_name: null,
                real_estate_typology_id: null,
                user_email_hashed: md5(props.email),
                user_email: props.email,
                user_id: props.publicUserId === -1 ? null : props.publicUserId
              });
              _context.next = 8;
              return addGenericRequest({
                sale: props.realEstateSearchBean.sale,
                rent: props.realEstateSearchBean.rent,
                auction: props.realEstateSearchBean.auction,
                priceSale: props.realEstateSearchBean.priceFrom,
                priceRent: props.realEstateSearchBean.priceFrom,
                auctionMinimumOffer: props.realEstateSearchBean.auctionMinimumOffer,
                typologyId: props.realEstateSearchBean.typologyId,
                macroTypologyId: props.realEstateSearchBean.macroTypologyId,
                cityId: props.realEstateSearchBean.cityId,
                zoneId: props.realEstateSearchBean.zoneId,
                provinceId: props.realEstateSearchBean.provinceId,
                regionId: props.realEstateSearchBean.regionId,
                districtId: props.realEstateSearchBean.districtId,
                name: props.isUserLogged ? props.name : requestData.value.name,
                email: props.email,
                phone: requestData.value.phone
              });
            case 8:
              if (!requestData.value.toggleMortgage) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return sendMortgage(mortgageData);
            case 11:
              sendGAEvent("mortgage", {
                event_location: event_location
              });
            case 12:
              isLoading.value = false;
              if (requestData.value.toggleMortgage || requestData.value.toggleGeneric) showMessageSentSuccess.value = true;else closedModal();
              _context.next = 20;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
              showError.value = true;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 16]]);
      }));
    };
    /*
    const checkIfValidPhone = (): boolean => {
        const validPhone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
        isValidPhone.value = validPhone.test(requestData.value?.phone);
        return isValidPhone.value
    }
    */
    var openWikiPrivacy = function openWikiPrivacy() {
      var privacyUrl = "/privacy/#informativa-j";
      window.open(privacyUrl, "_blank", "scrollbars=yes, width=550, height=600");
    };
    return function (_ctx, _cache) {
      return showMessageSentSuccess.value ? (_openBlock(), _createBlock(GenericSuccessModal, {
        key: 0,
        "show-modal": showMessageSentSuccess.value,
        labels: {
          actual_title: "Richiesta inviata",
          actual_label: "La richiesta \xE8 stata inviata correttamente"
        },
        "auto-close": 3000,
        onClosed: closedModal
      }, null, 8 /* PROPS */, ["show-modal"])) : (_openBlock(), _createBlock(BaseBtModal, {
        key: 1,
        id: "share-modal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return show.value = $event;
        }),
        "data-cy": "share-modal",
        "show-modal": show.value,
        "custom-modal-dialog-classes": "modal-lg",
        "with-custom-footer": true,
        onClosed: closedModal
      }, {
        header: _withCtx(function () {
          return [_createVNode(BaseAlert, {
            "alrt-class": "tw-alert tw-alert-w-primary tw-mr-35px !tw-mb-0"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
                src: "".concat(_unref(cdn), "/_ui/img/Ico/icon-done-blue.svg"),
                width: "20",
                height: "20",
                alt: "done icon"
              }, null, 8 /* PROPS */, _hoisted_2), _hoisted_3])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createVNode(BaseToggle, {
            modelValue: requestData.value.toggleGeneric,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return requestData.value.toggleGeneric = $event;
            }),
            label: 'Voglio ricevere proposte simili da agenzie immobiliari',
            "class": "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px tw-text sm:tw-text-16 tw-font-medium"
          }, null, 8 /* PROPS */, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(BaseToggle, {
            modelValue: requestData.value.toggleMortgage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return requestData.value.toggleMortgage = $event;
            }),
            label: '',
            "class": "tw-w-full tw-flex tw-flex-row-reverse tw-justify-between tw-pr-10px tw-text sm:tw-text-16 tw-font-medium"
          }, {
            rightLabel: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("img", {
                "class": "tw-mx-5px tw-w-auto sm:tw-block",
                width: "73",
                height: "25",
                src: "".concat(_unref(cdn), "/_ui/img/adv/credipass-logo-new.webp"),
                alt: "logo credipass"
              }, null, 8 /* PROPS */, _hoisted_8)])];
            }),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_9, [!_ctx.isUserLogged ? (_openBlock(), _createBlock(BaseInput, {
            key: 0,
            id: "name",
            modelValue: requestData.value.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return requestData.value.name = $event;
            }),
            name: "name",
            "label-text": "Nome",
            "is-valid": _unref(isValid)(_unref(v$).requestData.name)
          }, null, 8 /* PROPS */, ["modelValue", "is-valid"])) : _createCommentVNode("v-if", true), _createVNode(BaseInput, {
            id: "phone",
            modelValue: requestData.value.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return requestData.value.phone = $event;
            }),
            name: "phone",
            type: "tel",
            "label-text": "Telefono",
            "is-valid": _unref(isValid)(_unref(v$).requestData.phone)
          }, null, 8 /* PROPS */, ["modelValue", "is-valid"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_createTextVNode(" Cliccando "), _hoisted_11, _createTextVNode(", dichiaro di aver preso visione dell' "), _createElementVNode("span", {
            innerHTML: _unref(wkLabels).privacyPolicy2
          }, null, 8 /* PROPS */, _hoisted_12), _createTextVNode(" ("), _createElementVNode("a", {
            "class": "tw-underline",
            href: "#",
            onClick: _withModifiers(openWikiPrivacy, ["prevent"]),
            innerHTML: _unref(wkLabels).purpose + ' J'
          }, null, 8 /* PROPS */, _hoisted_13), _createTextVNode(") ")])])], 512 /* NEED_PATCH */), [[_vShow, requestData.value.toggleGeneric || requestData.value.toggleMortgage]])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_14, [_createVNode(BaseButton, {
            "data-cy": "sss-modal-confirm",
            "class": "tw-self-start tw-mx-0 sm:tw-mx-auto tw-w-full w-sm-auto sm:tw-max-w-[172px] tw-mt-20px sm:tw-mt-0",
            "btn-class": "tw-btn-w-primary",
            "is-loading": isLoading.value,
            disabled: (requestData.value.toggleGeneric || requestData.value.toggleMortgage) && (_unref(v$).requestData.phone.$invalid || _unref(v$).requestData.name.$invalid),
            onClick: _withModifiers(submitRequest, ["stop"])
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("span", {
                innerHTML: _ctx.labels.genericConfirm
              }, null, 8 /* PROPS */, _hoisted_15)];
            }),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["is-loading", "disabled"]), showError.value ? (_openBlock(), _createElementBlock("span", _hoisted_16)) : _createCommentVNode("v-if", true)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "show-modal"]));
    };
  }
});